export const ButtonStyles = {
    responsiveButtonWithText: {
        container: "flex items-center space-x-2 w-full",
        smallDeviceView: " w-full",
        smallDeviceButton: "sm:hidden",
        largeDeviceContainer: "hidden sm:flex items-center space-x-2",
        gradientContainer: "rounded-xl bg-gradient-to-r from-iw-primary to-iw-secondary p-[2px] transition-all duration-200 ease-in-out",
        iconButton: "flex items-center justify-center w-10 h-10 rounded-xl shadow border-none bg-[#FBF2EF] transition-all duration-200 ease-in-out",
        hoveredIconButton: "bg-gradient-to-r from-iw-primary to-iw-secondary"
    }
}